<ng-container *ngFor="let group of filterGroups">
  <div
    class="card mb-5"
    [ngClass]="{
      'p-0 has-background-white no-border': group.filters[0].title === 'Search',
      'pb-5': group.filters[0].title !== 'Search'
    }"
    *ngIf="!group.isHidden"
  >
    <h3 class="is-size-6 is-sans mb-4 is-uppercase is-bold" *ngIf="group.name">
      {{ group.name }}
    </h3>
    <ng-container *ngFor="let filter of group.filters">
      <div
        class="field list"
        *ngIf="
          filter.options?.length > 0 ||
          filter.filterType === FilterType.TextInput ||
          filter.filterType === FilterType.SelectAutocomplete
        "
      >
        <nav
          class="level my-0 py-0 pointer"
          *ngIf="group.filters[0].title !== 'Search'"
          (click)="filter.isOpen = !filter.isOpen"
          (keydown)="filter.isOpen = !filter.isOpen"
          tabindex="0"
        >
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <span>
                <p class="is-size-8 is-uppercase my-0 is-bold">
                  {{ filter.title | stripHtml }}
                  <span
                    *ngIf="filter.helpText"
                    class="has-tooltip has-tooltip-top has-tooltip-multiline has-tooltip-primary"
                    [attr.data-tooltip]="filter.helpText"
                  >
                    <i class="icon icon-Info has-text-grey"></i>
                  </span>
                </p>
              </span>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right">
            <p class="level-item my-0">
              <span>
                <i
                  class="icon is-size-7"
                  [ngClass]="{
                    'icon-Top': filter.isOpen,
                    'icon-Down': !filter.isOpen
                  }"
                ></i>
              </span>
            </p>
          </div>
        </nav>
        <nav
          class="level my-0 py-0"
          *ngIf="group.filters[0].title === 'Search'"
        >
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <span>
                <p class="is-size-8 is-uppercase mt-0 mb-2 is-bold">
                  {{ filter.title | stripHtml }}
                  <span
                    *ngIf="filter.helpText"
                    class="has-tooltip-right has-tooltip-multiline has-tooltip-primary"
                    [attr.data-tooltip]="filter.helpText"
                  >
                    <i class="icon icon-Info has-text-grey"></i>
                  </span>
                </p>
              </span>
            </div>
          </div>
        </nav>
        <div
          class="py-0"
          *ngIf="
            ((filter.options && filter.options.length) ||
              filter.filterType === FilterType.TextInput ||
              filter.filterType === FilterType.SelectAutocomplete) &&
            filter.isOpen
          "
        >
          <app-multi-tags-input
            [values]="filter.options"
            placeholder="Filter by..."
            (selectedValuesChanged)="onFilterChanged($event, filter.queryParam)"
            [initialValues]="filter.initialIds"
            *ngIf="filter.filterType === FilterType.MultiTags"
          ></app-multi-tags-input>
          <p class="pb-3 my-0" *ngIf="isFilterSelected(filter)">
            <a
              class="content is-small ghost has-text-dark mr- is-size-7 has-tooltip-primary has-tooltip-arrow has-text-primary has-text-right remove-selection"
              data-tooltip="Clear all the selection for this filter"
              (click)="clearFilterSelectedOptions(filter)"
              (keydown)="clearFilterSelectedOptions(filter)"
              tabindex="0"
            >
              <span>Clear all</span>
            </a>
          </p>
          <app-check-box-input
            [choices]="filter.options"
            (selectedChoiceIdsChanged)="
              onFilterChanged($event, filter.queryParam)
            "
            [selectedChoiceIds]="filter.initialIds"
            *ngIf="filter.filterType === FilterType.CheckBox"
          ></app-check-box-input>
          <div class="has-small-field">
            <app-search-input
              [initialValue]="filter.initialValue"
              analyticsEvent="search_{{ resourceSlug }}"
              (termsChanged)="onFilterChanged($event, filter.queryParam)"
              *ngIf="filter.filterType === FilterType.TextInput"
            ></app-search-input>
          </div>

          <app-select-autocomplete-input
            [searchFunction]="filter.searchFunction"
            [initialValueFetchFunction]="filter.initialValueFetchFunction"
            [initialValue]="filter.initialIds"
            [maxSelectedSearchResults]="20"
            (selectionChanged)="
              onFilterChanged($event ? $event : null, filter.queryParam)
            "
            *ngIf="filter.filterType === FilterType.SelectAutocomplete"
          ></app-select-autocomplete-input>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
